import React from 'react';
import { ChevronRight } from 'lucide-react';

const Breadcrumb = ({ items }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#888' }}>
    {items.map((item, i) => (
      <React.Fragment key={i}>
        {i > 0 && <ChevronRight size={14} color="#CCC" />}
        {item.onClick ? (
          <span
            onClick={item.onClick}
            style={{ cursor: 'pointer', color: i === items.length - 1 ? '#333' : '#20B967', fontWeight: i === items.length - 1 ? 600 : 400, transition: 'opacity 0.2s' }}
            onMouseEnter={e => { if (item.onClick) e.target.style.opacity = '0.7'; }}
            onMouseLeave={e => { e.target.style.opacity = '1'; }}
          >
            {item.label}
          </span>
        ) : (
          <span style={{ color: '#333', fontWeight: 600 }}>{item.label}</span>
        )}
      </React.Fragment>
    ))}
  </div>
);

export default Breadcrumb;
